module.exports = {
  host: process.env.HOST || 'localhost',
  open: true,
  port: process.env.PORT || 8081,
  apiRoot: process.env.VUE_APP_API_ROOT || 'http://localhost:8001',
  project: {
    // from base-touchscreen branch (e.g.: T-Place and ReMap)
    titleLogo: true,
    logoSize: 'wide', // 'normal'
    subtitle: ``,
    menuSubtitle: '',
    footerTitle: 'Eredità Culturali Aperte Digitali &copy; 2026',
    footerText: `<div class="grid grid-cols-2 w-full md:w-4/5 lg:w-3/4 xl:w-1/2 m-auto gap-10 py-10">
      <div class="col-span-2 md:col-span-1 footer-1 text-xs/6">
        <div class="text-center">
          Content license: CC BY-SA 4.0 International<br/>
          Metadata license: CC0 1.0 Universal
        </div>
      </div>
      <div class="col-span-2 md:col-span-1 footer-2 text-left text-xs/6">
        <div class="text-center">
          Realizzazione Web a cura di:<br/>
          LiEC - Laboratorio interdisciplinare sulle Eredità Culturali<br/>
          Dipartimento SAGAS, Università degli Studi di Firenze
        </div>
      </div>
    </div>`,
    copyright: 'LiEC @ 2026',
    subtitleSize: 'sm',
    font: {
      title: 'font-titillium',
      body: 'font-titillium'
    },
    style: {
      background: 'bg-white',
      homeText: 'text-white',
      text: 'text-black',
      color: '#000'
    },
    bars: {
      top: { position: 'top', cols: 8, logoSize: 4, logoLink: '/', logoAlt: 'Logo Top', menuSize: 4, hideOnMobile: true},
      main: { position: 'main', cols: 8, logoSize: 2, logoLink: '/', logoAlt: process.env.VUE_APP_NAME, menuSize: 6}
    },
  },
  search: {
    models: [
      {value: 'cards', label: 'Schede'},
      {value: 'persons', label: 'Persone'},
      {value: 'card_containers', label: 'Contenitori Schede'},
      {value: 'scan_cards', extends: 'cards', label: 'Scheda SCAN',},
      {value: 'f_cards', extends: 'cards', label: 'Scheda F'},
      {value: 'collections', label: 'Album'},
    ],
    fields: [
      {field: 'tags', type: 'select-api', label: 'Tags', vocabulary: 'tags'}
    ]
  },
  templates: {
    persons: ['tags', 'map', 'gallery', 'start_fields', 'related_entities', 'end_fields', 'references'],
    scan_cards: ['tags', 'map', 'gallery', 'persons', 'card_containers', 'cardable_start_fields', 'related_entities', 'cardable_end_fields', 'references', 'relateds', 'attachments'],
    f_cards: ['tags', 'gallery', 'collection', 'persons', 'map', 'card_containers', 'cardable_start_fields', 'related_entities', 'cardable_end_fields', 'references', 'relateds'],
    itinerary: ['description', 'map', 'timeline_vertical'],
    'landscape-itinerary': ['description', 'timeline_horizontal'],
    'temporary-exhibition' : ['description', 'cards'],
    exhibition: ['description', 'cards'],
    'art-collection': ['description', 'cards'],
    glossary: ['description', 'cards'],
    collections: ['tags', 'description', 'gallery', 'f_cards'],
    references: ['tags', 'fields', 'cards', 'persons']
  },
  models: {
    scan_cards: { 
      extended: true, 
      single: 'Scheda SCAN', 
      plural: 'Schede SCAN', 
      visibility: 'all',
      fields: [
        // Identificazione (CD)
        {field: 'tsk', type: 'text', label: 'Tipo scheda (TSK)', position: 'start', visibility: 'all'},
        {field: 'lir', type: 'text', label: 'Livello catalogazione (LIR)', position: 'start', visibility: 'all'},
        {field: 'nctr',type: 'text', label: 'Codice regione (NCTR)', position: 'start', visibility: 'all'},
        {field: 'nctn',type: 'text', label: 'Numero catalogo generale (NTCN)', position: 'start', visibility: 'all'},
        {field: 'esc', type: 'text', label: 'Ente schedatore (ESC)', position: 'start', visibility: 'all'},
        {field: 'ecp', type: 'text', label: 'Ente competente per tutela (ECP)', position: 'start', visibility: 'all'},
        {field: 'acce',type: 'text', label: 'Ente/soggetto responsabile (ACCE)', position: 'start', visibility: 'all'},
        {field: 'accw',type: 'repeating', label: 'Indirizzo web (ACCW)', position: 'start', visibility: 'all'}, // ripetibile con |
        {field: 'accr',type: 'text', label: 'Riferimento cronologico (ACCR)', position: 'start', visibility: 'all'},
        {field: 'accs',type: 'text', label: 'Note (ACCS)', position: 'start', visibility: 'all'},

        // Bene culturale (OG)
        {field: 'ctb', type: 'text', label: 'Categoria generale (CTB)', position: 'start', visibility: 'all'},
        {field: 'set', type: 'text', label: 'Settore disciplinare (SET)', position: 'start', visibility: 'all'},
        {field: 'tbc', type: 'text', label: 'Tipo bene culturale (TBC)', position: 'start', visibility: 'all'},
        {field: 'ctg', type: 'text', label: 'Categoria disciplinare (CTG)', position: 'start', visibility: 'all'},
        {field: 'ogd', type: 'text', label: 'Definizione bene (OGD)', position: 'start', visibility: 'all'},
        {field: 'ogt', type: 'text', label: 'Tipologia/altre specifiche (OGT)', position: 'start', visibility: 'all'},
        {field: 'ogn', type: 'repeating', label: 'Denominazione/titolo (OGN)', position: 'start', visibility: 'all'}, // ripetibile con |

        // Relazioni (RV)
        // {field: 'rser',type: 'text', label: 'Tipo di relazione (RSER)', position: 'start', visibility: 'all'},
        // {field: 'rses',type: 'text', label: 'Specifiche tipo relazione (RSES)', position: 'start', visibility: 'all'},
        // {field: 'rez', type: 'text', label: 'Note sulle relazioni (REZ)', position: 'start', visibility: 'all'},

        // Localizzazione (LC)
        {field: 'lcs', type: 'text', label: 'Stato (LCS)', position: 'start', visibility: 'all'},
        {field: 'lcr', type: 'select-api', vocabulary: 'regions', label: 'Regione (LCR)', position: 'start', visibility: 'all'},
        {field: 'lcp',type: 'select-api', vocabulary: 'provinces', label: 'Provincia (LCP)', position: 'start', visibility: 'all'},
        {field: 'lcc', type: 'text', label: 'Comune (LCC)', position: 'start', visibility: 'all'},
        {field: 'lci', type: 'text', label: 'Indirizzo (LCI)', position: 'start', visibility: 'all'},
        {field: 'lcv', type: 'text', label: 'Altri percorsi/specifiche (LCV)', position: 'start', visibility: 'all'},
        {field: 'plv', type: 'repeating', label: 'Toponimo / Località (PLV)', position: 'start', visibility: 'all'},
        {field: 'pvz', type: 'text', label: 'Tipo di contesto (PVZ)', position: 'start', visibility: 'all'},

        // Georeferenziazione (GE)
        {field: 'gel', type: 'text', label: 'Tipo di localizzazione (GEL)', position: 'start', visibility: 'all'},
        {field: 'get', type: 'text', label: 'Tipo di georeferenziazione (GET)', position: 'start', visibility: 'all'},
        {field: 'gep', type: 'text', label: 'Sistema di riferimento (GEP)', position: 'start', visibility: 'all'},
        {field: 'gec', type: 'text', label: 'Coordinate (GEC)', position: 'start', visibility: 'all'},
        {field: 'gecx',type: 'text', label: 'Coordinata x (GECX)', position: 'start', visibility: 'all'},
        {field: 'gecy',type: 'text', label: 'Coordinata y (GECY)', position: 'start', visibility: 'all'},
        {field: 'aff', type: 'select-api', vocabulary: 'accuracy', label: 'Affidabilità (AFF)', position: 'start', visibility: 'all'},
        {field: 'gpbb',type: 'text', label: 'Descrizione sintetica (GPBB)', position: 'start', visibility: 'all'},
        {field: 'gpbt',type: 'text', label: 'Data (GPBT)', position: 'start', visibility: 'all'},
        {field: 'gpbu',type: 'text', label: 'Indirizzo web (GPBU)', position: 'start', visibility: 'all'},

        // Cronologia / Definizione Culturale (DT)
        {field: 'dtzg',type: 'text', label: 'Fascia cronologica/periodo (DTZG)', position: 'start', visibility: 'all'},
        {field: 'dtzs',type: 'text', label: 'Specifiche (DTZS)', position: 'start', visibility: 'all'},
        {field: 'dtsi',type: 'text', label: 'Da (DTSI)', position: 'start', visibility: 'all'},
        {field: 'dtsv',type: 'text', label: 'Validità Da (DTSV)', position: 'start', visibility: 'all'},
        {field: 'dtsf',type: 'text', label: 'A (DTSF)', position: 'start', visibility: 'all'},
        {field: 'dtsl',type: 'text', label: 'Validità A (DTSL)', position: 'start', visibility: 'all'},
        {field: 'dtt', type: 'text', label: 'Note (DTT)', position: 'start', visibility: 'all'},
        {field: 'atb', type: 'text', label: 'Ambito culturale (ATB)', position: 'start', visibility: 'all'},

        // Dati analitici (DA)
        {field: 'des', type: 'text', label: 'Descrizione del bene (DES)', position: 'start', visibility: 'all'},
        {field: 'aid', type: 'text', label: 'Apparato iconografico/decorativo (AID)', position: 'start', visibility: 'all'},
        {field: 'res', type: 'text', label: 'Dati provenienza archeologica (RES)', position: 'start', visibility: 'all'},
        {field: 'nsc', type: 'text', label: 'Approndimenti storico-critici (NSC)', position: 'start', visibility: 'all'},

        // Dati tecnici (MT)
        {field: 'nvc', type: 'text', label: 'Provvedimenti amministrativi-specifiche (NVC)', position: 'start', visibility: 'all'},

        // Bibliografia (BIB)
        {field: 'bib', type: 'repeating', label: 'Bibliografia (BIB)', position: 'end', visibility: 'all'}, // ripetibile con |

        // Altri campi
        {field: 'cam', type: 'text', label: 'Caratteri ambientali beni immobili (CAM)', position: 'start', visibility: 'profile'},
        {field: 'ro',  type: 'repeating', label: 'Risorse Online', position: 'start', visibility: 'profile'}, // ripetibile con |

        {field: 'cmr', type: 'text', label: 'Responsabile (CMR)', position: 'start', visibility: 'all'},
        {field: 'cma', type: 'text', label: 'Anno di redazione (CMA)', position: 'start', visibility: 'all'},
        {field: 'adp', type: 'text', label: 'Profilo di pubblicazione (ADP)', position: 'start', visibility: 'all'},
        // position => 'end' va mostrato nella parte finale del layout della scheda
      ],
      related: ['scan_documentations', 'scan_historicals', 'scan_certifications', 'scan_measures', 'scan_authorities'],
      pivot: {
        locations: [
          {field: 'type',type: 'text', label: 'Tipo di luogo', position: 'start', visibility: 'all'},
          {field: 'location_person_type_id',type: 'text', label: 'Tipo di luogo', position: 'start', visibility: 'all'},
          {field: 'description',type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ],
        cards: [
          {field: 'card_person_type_id',type: 'text', label: 'Tipo di scheda', position: 'start', visibility: 'all'},
          {field: 'description',type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ]
      },
      reference_format: [
        {field: 'author', format: 'normal', separator: ', '},
        {field: 'title', format: 'normal', separator: ', '},
        {field: 'place', format: 'normal', separator: ' '},
        {field: 'year', format: 'normal', separator: ' '},
        {field: 'citation', format: 'normal', separator: ''},
      ]
    },
    f_cards: { 
      extended: true, 
      single: 'Scheda F', 
      plural: 'Schede F',
      visibility: 'all',
      fields: [
        {field: 'inventario', type: 'text', label: 'Inventario', position: 'start', visibility: 'all'},
        {field: 'archivio', type: 'text', label: 'Archivio', position: 'start', visibility: 'all'},
        {field: 'fondo_collezione', type: 'text', label: 'Collezione', position: 'start', visibility: 'all'},
        {field: 'ente_produttore', type: 'text', label: 'Ente produttore', position: 'start', visibility: 'all'},
        {field: 'foglio_IGM', type: 'text', label: 'Foglio IGM', position: 'start', visibility: 'all'},
        {field: 'numero_inventario_patrimoniale', type: 'text', label: 'Numero inventario patrimoniale', position: 'start', visibility: 'all'},
        {field: 'collocazione', type: 'text', label: 'Collocazione', position: 'start', visibility: 'all'},
        {field: 'codice_univoco', type: 'text', label: 'Codice univoco', position: 'start', visibility: 'all'},
        {field: 'definizione_oggetto', type: 'text', label: 'Definizione oggetto', position: 'start', visibility: 'all'},
        {field: 'unita_archivistica', type: 'text', label: 'Unità archivistica', position: 'start', visibility: 'all'},
        {field: 'indicazione_colore', type: 'text', label: 'Indicazione colore', position: 'start', visibility: 'all'},
        {field: 'materia_tecnica_oggetto', type: 'text', label: 'Materia e tecnicaoggetto', position: 'start', visibility: 'all'},
        {field: 'misure_formato', type: 'text', label: 'Misure e format', position: 'start', visibility: 'all'},
        {field: 'cronologia_generica', type: 'text', label: 'Cronologia generica', position: 'start', visibility: 'all'},
        {field: 'cronologia_specifica', type: 'text', label: 'Cronologia specifica', position: 'start', visibility: 'all'},
        {field: 'autore_fotografia', type: 'text', label: 'Autore fotografia', position: 'start', visibility: 'all'},
        {field: 'editore', type: 'text', label: 'Editore', position: 'start', visibility: 'all'},
        {field: 'categorie', type: 'text', label: 'Categorie', position: 'start', visibility: 'all'},
        {field: 'soggetto', type: 'repeating', label: 'Soggetto', position: 'start', visibility: 'all'},
        {field: 'titolo', type: 'text', label: 'Titolo', position: 'start', visibility: 'all'},
        {field: 'luogo_ripresa', type: 'text', label: 'Luogo ripresa', position: 'start', visibility: 'all'},
        {field: 'data_ripresa', type: 'text', label: 'Data ripresa', position: 'start', visibility: 'all'},
        {field: 'cronologia_opera_fotografata', type: 'text', label: 'Cronologia opera fotografata', position: 'start', visibility: 'all'},
        {field: 'autore_opera_fotografata', type: 'text', label: 'Autore opera fotografata', position: 'start', visibility: 'all'},
        {field: 'iscrizioni_timbri', type: 'text', label: 'Iscrizioni timbri', position: 'start', visibility: 'all'},
        {field: 'alterazioni_deterioramenti', type: 'text', label: 'Alterazioni deterioramenti', position: 'start', visibility: 'all'},
        {field: 'data_restauro', type: 'text', label: 'Data restauro', position: 'start', visibility: 'all'},
        {field: 'mostre', type: 'text', label: 'Mostre', position: 'start', visibility: 'all'},
        {field: 'numero_riproduzione', type: 'text', label: 'Numero riproduzione', position: 'start', visibility: 'all'},
        {field: 'numero_fotografia_originale', type: 'text', label: 'Numero fotografia originale', position: 'start', visibility: 'all'},
        {field: 'collocazione_riproduzione_stampa', type: 'text', label: 'Collocazione riproduzione stampa', position: 'start', visibility: 'all'},
        {field: 'funzionario_responsabile', type: 'text', label: 'Funzionario responsabile', position: 'start', visibility: 'all'},
        {field: 'bibliografia_specifica', type: 'repeating', label: 'Bibliografia specifica', position: 'end', visibility: 'all'},
      ],
      related: ['f_certifications'],
      collection_format: [
        {field: 'name', label: 'Nome Album'},
        {field: 'bibliography', label: 'Bibliografia'}
      ]
    },
    persons: { 
      single: 'Persona', 
      plural: 'Persone', 
      visibility: 'all', 
      color: 'blue',
      fields: [
        {field: 'name', type: 'text', label: 'Nome scelto', position: 'start', visibility: 'all'},
        {field: 'pre_name', type: 'text', label: 'Prenome', position: 'start', visibility: 'all'},
        {field: 'first_name', type: 'repeating', label: 'Primo nome', position: 'start', visibility: 'all'},
        {field: 'middle_name', type: 'text', label: 'Secondo nome', position: 'start', visibility: 'all'},
        {field: 'last_name', type: 'repeating', label: 'Cognome', position: 'start', visibility: 'all'},
        {field: 'title', type: 'text', label: 'Titolo', position: 'start', visibility: 'all'},
        {field: 'nick_name', type: 'repeating', label: 'Soprannome', position: 'start', visibility: 'all'},
        {field: 'initials', type: 'text', label: 'Iniziali', position: 'start', visibility: 'profile'},
        {field: 'sex', type: 'text', label: 'Sesso', position: 'start', visibility: 'all'},
        {field: 'birth_date', type: 'text', label: 'Data di nascita', position: 'start', visibility: 'all'},
        {field: 'birth_place', type: 'text', label: 'Luogo di nascita', position: 'start', visibility: 'all'},
        {field: 'death_date', type: 'text', label: 'Data del decesso', position: 'start', visibility: 'all'},
        {field: 'death_place', type: 'text', label: 'Luogo del decesso', position: 'start', visibility: 'all'},
        {field: 'from_date', type: 'text', label: 'Data nascita testuale', position: 'start', visibility: 'all'},
        {field: 'to_date', type: 'text', label: 'Data del decesso estuale', position: 'start', visibility: 'all'},
        {field: 'notes', type: 'text', label: 'Note', position:'start', visibility: 'profile'},
        {field: 'origin', type: 'text', label: 'Origine', position:'start', visibility: 'profile'},
        {field: 'nationality', type: 'text', label: 'Nazionalità', position: 'start', visibility: 'all'},
        {field: 'website', type: 'text', label: 'Link sito web', position: 'start', visibility: 'all'},
        {field: 'biography', type: 'text', label: 'Biografia', position: 'end', visibility: 'all'},
      ],
      pivot: {
        locations: [
          {field: 'location_person_type_id', type: 'text', label: 'Tipo di luogo', position: 'start', visibility: 'all'},
          {field: 'description', type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ],
        cards: [
          {field: 'card_person_type_id', type: 'text', label: 'Tipo di scheda', position: 'start', visibility: 'all'},
          {field: 'description', type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ],
        related: ['cards']
      }
    },
    card_containers: {
      single: 'Contenitore Schede',
      plural: 'Contenitori Schede',
      visibility: 'all',
      color: 'yellow',
      fields: [
        {field: 'name',         type: 'text', label: 'Nome'},
        {field: 'description',  type: 'text', label: 'Descrizione'},
        {field: 'code',         type: 'text', label: 'Codice'},
        {field: 'card_container_type_id', type: 'text', label: 'Tipologia', position: 'start', visibility: 'all'},
      ],
      pivot: {
        cards: [
          {field: 'start_date', type: 'date', label: 'Data inizio', position: 'start', visibility: 'all'},
          {field: 'end_date', type: 'date', label: 'Data fine', position: 'start', visibility: 'all'},
          {field: 'description', type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ]
      },
    },
    references: {
      single: 'Riferimento bibliografico',
      plural: 'Riferimenti bibliografici',
      visibility: 'all',
      color: 'purple',
      fields: [
        {field: 'title', type: 'text', label: 'Titolo', position: 'start', separator: ', '},
        {field: 'author', type: 'text', label: 'Autore', position: 'start', visibility: 'all', separator: ', '},
        {field: 'year', type: 'text', label: 'Anno', position: 'start', visibility: 'all', separator: ' '},
        {field: 'citation', type: 'text', label: 'Citazione', format: 'normal', separator: ''},
      ],
      pivot: {
        cards: [
          {field: 'citation', type: 'text', label: 'Citazione', position: 'start', visibility: 'all'}
        ]
      },
    },
    cards: {
      single: 'Scheda',
      plural: 'Schede',
      visibility: 'all',
      color: 'green',
      fields: [
        {field: 'name', type: 'text', label: 'Nome'},
        {field: 'description', type: 'text', label: 'Descrizione'},
        {field: 'code', type: 'text', label: 'Codice'},
        {field: 'regione', type: 'select-api', label: 'Regione', vocabulary: 'regions'},
        {field: 'provincia', type: 'select-api', label: 'Provincia', vocabulary: 'provinces'},
      ],
      pivot: {
        persons: [
          {field: 'card_person_type_id', type: 'text', label: 'Tipo di scheda', position: 'start', visibility: 'all'},
          {field: 'description', type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ],
        cards: [
          {field: 'description', type: 'text', label: 'Note sulle relazioni (REZ)', position: 'start', visibility: 'all'},
          {field: 'direction', type: 'text', label: 'Specifiche tipo relazione (RSES)', position: 'start', visibility: 'all'},
          {field: 'type', type: 'vocabulary', label: 'Tipo di relazione (RSER)', position: 'start', visibility: 'all'},
          {field: 'notes', type: 'text', label: 'Altre note', position: 'start', visibility: 'all'},
        ]
      }
    },
    collections: {
      single: 'Collezione',
      plural: 'Collezioni',
      visibility: 'all',
      color: 'yellow',
      fields: [
        {field: 'name', type: 'text', label: 'Nome', position: 'start', visibility: 'all'},
        {field: 'bibliography', type: 'text', label: 'Bibliografia', position: 'start', visibility: 'all'},
      ],
      pivot: {
        f_cards: [
          {field: 'name', type: 'text', label: 'Nome', position: 'start', visibility: 'all'},
        ]
      },
      related: ['f_cards']
    },
    scan_documentations: {
      single: 'Documentazione (DO)',
      plural: 'Documentazione (DO)',
      visibility: 'all',
      fields: [
        {field: 'dcmn', type: 'text', label: 'Codice identificativo (DCMN)', position: 'start', visibility: 'all'},
        {field: 'dcmp', type: 'text', label: 'Tipo (DCMP)', position: 'start', visibility: 'all'},
        {field: 'dcmm', type: 'text', label: 'Titolo/didascalia (DCMM)', position: 'start', visibility: 'all'},
        {field: 'dcma', type: 'text', label: 'Autore (DCMA)', position: 'start', visibility: 'all'},
        {field: 'dcmr', type: 'text', label: 'Riferimento cronologico (DCMR)', position: 'start', visibility: 'all'},
        {field: 'dcme', type: 'text', label: 'Ente proprietario (DCME)', position: 'start', visibility: 'all'},
        {field: 'dcmc', type: 'text', label: 'Collocazione (DCMC)', position: 'start', visibility: 'all'},
        {field: 'dcmw', type: 'text', label: 'Indirizzo web (DCMW)', position: 'start', visibility: 'all'},
        {field: 'dcmk', type: 'text', label: 'Nome file (DCMK)', position: 'start', visibility: 'all'},
        {field: 'dcmt', type: 'text', label: 'Note (DCMT)', position: 'start', visibility: 'all'},
      ],
      related: ['scan_cards']
    },
    scan_historicals: {
      single: 'Notizia storica (DTN)',
      plural: 'Notizie storiche (DTN)',
      visibility: 'profile',
      fields: [
        {field: 'dtns', type: 'text', label: 'Notizia di sintesi (DTNS)', position: 'start', visibility: 'all'},
        {field: 'dtr', type: 'text', label: 'Riferimento cronologico (DTR)', position: 'start', visibility: 'all'},
        {field: 'dtg', type: 'text', label: 'Specifiche riferimento cronologico (DTG)', position: 'start', visibility: 'all'},
        {field: 'dtnn', type: 'text', label: 'Notizia di dettaglio (DTNN)', position: 'start', visibility: 'all'},
      ],
      related: ['scan_cards']
    },
    scan_certifications: {
      single: 'Voce di certificazione / gestione dati (CM)',
      plural: 'Voci di certificazione / gestione dati (CM)',
      visibility: 'all',
      fields: [
        {field: 'cmr', type: 'text', label: 'Responsabile (CMR)', position: 'start', visibility: 'all'},
        {field: 'cma', type: 'text', label: 'Anno di redazione (CMA)', position: 'start', visibility: 'all'},
        {field: 'adp', type: 'text', label: 'Profilo di pubblicazione (ADP)', position: 'start', visibility: 'all'},
        {field: 'oss', type: 'text', label: 'Note (OSS)', position: 'start', visibility: 'all'},
      ],
      related: ['scan_cards']
    },
    f_certifications: {
      single: 'Voce di certificazione / gestione dati (CM)',
      plural: 'Voci di certificazione / gestione dati (CM)',
      visibility: 'all',
      fields: [
        {field: 'cmr', type: 'text', label: 'Responsabile (CMR)', position: 'start', visibility: 'all'},
        {field: 'cma', type: 'text', label: 'Anno di redazione (CMA)', position: 'start', visibility: 'all'},
        {field: 'adp', type: 'text', label: 'Profilo di pubblicazione (ADP)', position: 'start', visibility: 'all'},
        {field: 'oss', type: 'text', label: 'Note (OSS)', position: 'start', visibility: 'all'},
      ],
      related: ['scan_cards']
    },
    scan_authorities: {
      single: 'Autore responsabilità (AUT)',
      plural: 'Autori responsabilità (AUT)',
      visibility: 'all',
      fields: [
        {field: 'autn', type: 'text', label: 'Nome di persona o Ente (AUTN)', position: 'start', visibility: 'all'},
        {field: 'auta', type: 'text', label: 'Indicazioni cronologiche (AUTA)', position: 'start', visibility: 'all'},
        {field: 'autz', type: 'text', label: 'Note (AUTZ)', position: 'start', visibility: 'all'},
        {field: 'autj', type: 'text', label: 'Ente schedatore (AUTJ)', position: 'start', visibility: 'all'},
        {field: 'auth', type: 'text', label: 'Codice identificativo (AUTH)', position: 'start', visibility: 'all'},
      ],
      related: ['scan_cards']
    },
    scan_measures: {
      single: 'Misura (MIS)',
      plural: 'Misure (MIS)',
      visibility: 'all',
      fields: [
        {field: 'misz', type: 'text', label: 'Tipo misura (MISZ)', position: 'start', visibility: 'all'},
        {field: 'misu', type: 'text', label: 'Unità di misura (MISU)', position: 'start', visibility: 'all'},
        {field: 'mism', type: 'text', label: 'Valore (MISM)', position: 'start', visibility: 'all'},
        {field: 'misv', type: 'text', label: 'Note (MISV)', position: 'start', visibility: 'all'},
      ],
      related: ['scan_cards']
    },
    pages: { 
      single: 'Pagina', 
      plural: 'Pagine', 
      visibility: 'all', 
      color: 'red',
      fields: [
        {field: 'title', type: 'text', label: 'Titolo', position: 'start', visibility: 'all'},
      ]
    }
  }
}